import React from 'react';
import { useTranslation } from 'react-i18next';

const Projects = () => {
    const { t } = useTranslation();
    
    const projects = [
        {
            title: t('projects.muchem.title'),
            description: t('projects.muchem.description'),
            technologies: t('projects.muchem.technologies', { returnObjects: true }),
            role: t('projects.role')
        },
        {
            title: t('projects.deepscreen2.title'),
            description: t('projects.deepscreen2.description'),
            technologies: t('projects.deepscreen2.technologies', { returnObjects: true }),
            role: t('projects.role')
        },
        {
            title: t('projects.mooc.title'),
            description: t('projects.mooc.description'),
            technologies: t('projects.mooc.technologies', { returnObjects: true }),
            role: t('projects.role')
        },
        {
            title: t('projects.tec.title'),
            description: t('projects.tec.description'),
            technologies: t('projects.tec.technologies', { returnObjects: true }),
            role: t('projects.role')
        },
        {
            title: t('projects.webInfra.title'),
            description: t('projects.webInfra.description'),
            technologies: t('projects.webInfra.technologies', { returnObjects: true }),
            role: t('projects.role')
        }
    ];

    return (
        <div className="page-content">
            <h1>{t('projects.title')}<span className="accent">.</span></h1>

            <div className="projects-grid">
                {projects.map((project, index) => (
                    <div key={index} className="project-card">
                        <div className="project-header">
                            <h3># {project.title}</h3>
                        </div>
                        {project.role && (
                            <div className="project-role">{project.role}</div>
                        )}
                        <p className="project-description">{project.description}</p>
                        <div className="project-technologies">
                            {project.technologies.map((tech, techIndex) => (
                                <span key={techIndex} className="tech-tag">
                                    {tech}
                                </span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Projects; 